<template>
  <div>
    <section class="flex column">
      <div class="box w100">
        <!-- account -->
        <div class="box-content">
          <div class="flex row w100">
            <!-- form account info -->
            <div class="flex-1 w100">
              <h4>Dados do Perfil</h4>
              <div class="flex w100 column margin-top-m">
                <div class="flex-1 w100">
                  <label>ID</label>
                  <input
                    class="input"
                    type="text"
                    v-model="user.id"
                    disabled=""
                    readonly=""
                  />
                </div>

                <div class="flex-1 w100 margin-top-m">
                  <label>Nome</label>
                  <input class="input" type="text" v-model="user.name" />
                </div>

                <div class="flex-1 w100 margin-top-m">
                  <label>EMAIL</label>
                  <input class="input" type="text" v-model="user.email" disabled="" readonly />
                </div>

                <div class="flex-1 w100 margin-top-m">
                  <label>Tema</label>
                  <select class="input" v-model="user.theme">
                    <option v-for="(c, index) in listThemes" :key="index" :value="c.value" :selected="c.value === user.theme">
                      {{ c.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="margin-top-l">
                <h4>Alterar Senha</h4>
                <div class="margin-top-s">
                  <p>Para fazer uma alteração de senha, basta clicar no botão abaixo e um e-mail de alteração será enviado para o e-mail do usuário.</p>
                  <div class="button secondary marign-top-s" @click="showModal = true">Solicitar Alteração de Senha</div>
                </div>
              </div>
              <div class="flex center margin-top-l">
                <div class="button primary" @click="updateProfile()">
                  SALVAR
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModal"
      description="Você tem certeza que deseja solicitar uma nova Senha?"
      @cancel="showModal = false;"
      @accept="sendRecoveryPassword()"
    ></modal-confirm>
  </div>
</template>

<script>

import { mapState } from "vuex";
import { recoveryPassword } from "@/services/auth";

import { updateUser } from "@/services/user";
import ModalConfirm from "@/components/modal/ModalConfirm";

export default {
  name: "config-account",
  components: {
    ModalConfirm
  },
  data() {
    return {
      loading: false,
      showModal: false,
      listThemes: [
        {
          value: 'LIGTH',
          label: 'Claro'
        },
        //{
        //  value: 'DARK',
        //  label: 'Escuro'
        //}
      ],
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  methods: {
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
    sendRecoveryPassword() {
      recoveryPassword({ email: this.user.email })
          .then(() => {
              this.$toast.success({
                  title: "Sucesso",
                  message: "Foi enviado um e-mail para redefinir a senha"
              });
          })
          .catch(error => {
              if (error && error.message === "request-canceled") {
                  return;
              }

              return this.$toast.error({
                  title: "Erro",
                  message: "Ocorreu um erro interno na sua solicitação"
              });
          })
          .finally(() => {
            this.showModal = false
          })
    },
    updateUser() {
      let params = {
        name: this.user.name,
        theme: this.user.theme,
      };
      updateUser(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Conta atualizada com sucesso",
          });
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao atualizar conta",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>

.actions {
  > div {
    margin-left: 4px;
  }
}

</style>
